import { DeleteDepartmentRequestSchema, DeleteDepartmentResponseSchema } from './delete-department.schema';
/**
 * Delete Department Endpoint Contract
 * Deletes a department by ID
 */ export const deleteDepartmentContract = {
    method: 'DELETE',
    path: '/api/v2/department/:id',
    description: 'Delete a department by ID',
    requestSchema: DeleteDepartmentRequestSchema,
    responseSchema: DeleteDepartmentResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'Department not found'
        }
    }
};

//# sourceMappingURL=delete-department.contract.js.map